import {Page} from "./Page";

export default class DevicePreamblePage extends Page {
    getNavTitle(): string {
        return 'Device Evaluation';
    }
}
